// Arms the client-side "session has expired" sign-out for a stored token.
//
// setTimeout takes a signed 32-bit delay. Anything above 2^31-1 ms (~24.8 days)
// is treated as 1 ms by browsers, so a 30-day remembered session would sign the
// user out on the spot. The delay is therefore capped, and when the cap fires
// the remaining time is re-read from the clock: sign out only once the session
// really has expired, otherwise re-arm for what is left.
//
// Returns the cleanup that cancels the pending timer (for effect teardown).

export const MAX_TIMER_DELAY_MS = 2 ** 31 - 1

export function armSessionExpiry(expiresAt: number, onExpire: () => void): () => void {
  let timer: ReturnType<typeof setTimeout> | undefined
  let cancelled = false

  const check = () => {
    if (cancelled) return
    const remaining = expiresAt - Date.now()
    if (remaining <= 0) { onExpire(); return }
    timer = setTimeout(check, Math.min(remaining, MAX_TIMER_DELAY_MS))
  }

  check()
  return () => {
    cancelled = true
    if (timer !== undefined) clearTimeout(timer)
  }
}
